import { ApiEvent } from "./event.model";

export class ApiCall extends ApiEvent {
    phone: string;
}  


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/models/call.model.ts